/**
 * @generated SignedSource<<c6c32644ca6816f0ff2bd35496f57e6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateresellerprogramnewPayload",
    "kind": "LinkedField",
    "name": "createresellerprogramnew",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResellerCommProgramCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResellerCommProgramCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c08b780c336aed2e10aeda960e173e1b",
    "id": null,
    "metadata": {},
    "name": "ResellerCommProgramCreateMutation",
    "operationKind": "mutation",
    "text": "mutation ResellerCommProgramCreateMutation(\n  $input: CreateresellerprogramnewInput!\n) {\n  createresellerprogramnew(input: $input) {\n    uuid\n  }\n}\n"
  }
};
})();

node.hash = "630696b899ca7efa6ac53285497c20a2";

module.exports = node;
